import styled from "styled-components";

const ListIngredient = styled.li`
  display: flex;
  justify-content: space-between;
  border-top: 1px solid rgba(0, 0, 0, 0.15);
  padding: 0 25px;
`;

export default ListIngredient;
